export default "__VITE_ASSET__CrpKe36r__"